import { withCompInfo } from '@wix/editor-elements-integrations'
import { minimumLabelFontSize } from '../../core/carmi/InputUtils/constants'
import { ComboBoxInputCSSVars, ComboBoxInputDefinition } from './ComboBoxInput'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { getCrossEditorsCssVars } from './common'
import { getInputHeightInPx, getLabelPaddingObject } from '../../core/mappers/inputUtils'

export const css = withCompInfo<ComboBoxInputCSSVars, ComboBoxInputDefinition>()(
	// @ts-ignore - remove once siteFonts is added to CompInfo
	['compProps', 'hasResponsiveLayout', 'compLayout', 'styleProperties', 'siteFonts', 'isMobileView'],
	// @ts-ignore - remove once siteFonts is added to CompInfo
	({ compProps, hasResponsiveLayout, compLayout, styleProperties, siteFonts, isMobileView }) => {
		const { textAlignment, labelMargin, labelMobileFontSize, inputHeight, inputHeightMobile } = compProps
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }
		const sharedVars = {
			'--arrowLeftPosition': textAlignment === 'right' ? '0' : 'auto',
			'--arrowRightPosition': textAlignment === 'right' ? 'auto' : '0',
			'--labelMarginBottom': `${labelMargin}px`,
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', labelMobileFontSize, minimumLabelFontSize),
			'--requiredIndicationDisplay':
				styleProperties.txtlblrq && styleProperties.txtlblrq !== 'transparent' ? 'inline' : 'none',
			...getCrossEditorsCssVars(compInfo, compProps),
			...getLabelPaddingObject(compProps),
		}
		return hasResponsiveLayout
			? sharedVars
			: {
					...sharedVars,
					height: 'auto',
					'--inputHeight': getInputHeightInPx({
						isMobileView,
						height: compLayout.height!,
						inputHeight: inputHeight!,
						inputHeightMobile: inputHeightMobile!,
					}),
			  }
	}
)
